import { render, staticRenderFns } from "./MKIcons.vue?vue&type=template&id=2ca0b0d8&"
import script from "./MKIcons.vue?vue&type=script&lang=js&"
export * from "./MKIcons.vue?vue&type=script&lang=js&"
import style0 from "./MKIcons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports